export var ScalaLight = {
    primaryBase: 'rgba(255, 255, 255, 1)',
    primaryOn: 'rgba(0, 0, 0, 1)',
    primaryVariant: 'rgba(210, 210, 210, 1)',
    primaryVariantOn: 'rgba(102, 102, 102, 1)',
    secondaryBase: 'rgba(59, 59, 59, 1)',
    secondaryOn: 'rgba(200, 200, 200, 1)',
    secondaryVariant: 'rgba(43, 43, 43, 1)',
    secondaryVariantOn: 'rgb(255, 255, 255)',
    highlightBase: 'rgba(255, 255, 255, 1)',
    highlightOn: 'rgba(210, 55, 45, 1)',
    highlightVariant: 'rgba(210, 55, 45, 1)',
    highlightVariantOn: 'rgba(255, 255, 255, 1)',
    dangerBase: 'rgba(209, 9, 29, 1)',
    dangerOn: 'rgba(255, 255, 255, 1)',
    dangerVariant: 'rgba(160, 10, 30, 0.89)',
    dangerVariantOn: 'rgb(255, 255, 255)',
    warningBase: 'rgba(255, 159, 69, 1)',
    warningOn: 'rgba(255, 255, 255, 1)',
    warningVariant: 'rgba(255, 126, 4, 1)',
    warningVariantOn: 'rgb(0, 0, 0)',
    successBase: 'rgba(111, 192, 27, 1)',
    successOn: 'rgba(255, 255, 255, 1)',
    successVariant: 'rgba(89, 154, 22, 1)',
    successVariantOn: 'rgb(0, 0, 0)',
    infoBase: 'rgba(141, 206, 215, 1)',
    infoOn: 'rgba(0, 0, 0, 1)',
    infoVariant: 'rgba(88, 183, 197, 1)',
    infoVariantOn: 'rgb(0, 0, 0)',
    mainBackground: 'rgba(230, 230, 230, 1)',
    mainOn: 'rgba(102, 102, 102, 1)',
    mainVariantBackground: 'rgb(161, 161, 161)',
    mainVariantOn: 'rgb(0, 0, 0)',
    ribbonBackground: 'rgba(43, 43, 43, 1)',
    ribbonOn: 'rgba(200, 200, 200, 1)',
    ribbonVariantBackground: 'rgba(239, 64, 53, 1)',
    ribbonVariantOn: 'rgba(255, 255, 255, 1)',
    ribbonBreadcrumbBackground: 'rgba(239, 64, 53, 1)',
    ribbonBreadcrumbOn: 'rgba(255, 255, 255, 1)',
    ribbonBreadcrumbVariantBackground: 'rgb(243, 115, 107)',
    ribbonBreadcrumbVariantOn: 'rgba(255, 255, 255, 1)',
    ribbonBorder: 'rgba(239,  64,  53, 0.25)',
    topnavBackground: 'rgba(230, 230, 230, 1)',
    topnavOn: 'rgba(102, 102, 102, 1)',
    topnavVariantBackground: 'rgb(161, 161, 161)',
    topnavVariantOn: 'rgb(0, 0, 0)',
    topnavTitleBackground: 'rgba(43, 43, 43, 1)',
    topnavTitleOn: 'rgba(230, 230, 230, 1)',
    sidenavBackground: 'rgba(43, 43, 43, 1)',
    sidenavOn: 'rgba(230, 230, 230, 1)',
    sidenavVariantBackground: 'rgba(239, 64, 53, 1)',
    sidenavVariantOn: 'rgba(255, 255, 255, 1)',
    sidenavOpenBackground: 'rgba(230, 230, 230, 1)',
    sidenavOpenOn: 'rgba(0, 0, 0, 1)',
    sidenavBorder: 'rgba(239,  64,  53, 0.25)',
    surfaceBackground: 'rgb(255, 255, 255)',
    surfaceOn: 'rgb(0, 0, 0)',
    surfaceBorder: 'none',
    scrollbarThumb: 'rgba(43, 43, 43, 1)',
    scrollbarTrack: 'rgba(136, 136, 136, 1)',
    formControlBackground: 'rgba(250, 250, 250, 1)',
    formControlOn: 'rgba(0, 0, 0, 1)',
    formControlBorder: 'rgba(136, 136, 136, 1)',
    formControlHoverBorder: 'rgba(0, 0, 0, 1)',
    formControlIcon: 'rgba(136, 136, 136, 1)',
    formControlHoverIcon: 'rgb(255, 255, 255)',
    formControlLabel: 'rgb(0, 0, 0)',
    formControlLabelCase: 'normal',
    formControlLabelSize: '1rem',
    formControlLabelLetterSpacing: 'unset',
    formControlPlaceholder: 'rgb(135, 135, 135)',
    formControlHint: 'rgb(0, 0, 0)',
    checkboxRadioBackground: 'rgba(0, 0, 0, 1)',
    checkboxRadioHoverBackground: 'rgba(0, 0, 0, 1)',
    sliderBar: 'rgba(250, 250, 250, 1)',
    sliderBarSelected: 'rgba(0, 0, 0, 1)',
    sliderHandle: 'rgba(0, 0, 0, 1)',
    modalBackground: 'rgb(230, 230, 230)',
    modalOn: 'rgb(0, 0, 0)',
    modalBorder: 'rgb(92, 92, 92)',
    modalSurfaceBackground: 'rgb(207, 207, 207)',
    modalSurfaceOn: 'rgb(0, 0, 0)',
    modalSurfaceBorder: 'none',
    dialogBorderRadius: '',
    dialogHeaderBackground: 'rgb(230, 230, 230)',
    dialogHeaderOn: 'rgb(0, 0, 0)',
    dialogFooterBackground: 'rgb(230, 230, 230)',
    dialogFooterOn: 'rgb(0, 0, 0)',
    tooltipBackground: 'rgb(51, 51, 51)',
    tooltipOn: 'rgb(255, 255, 255)',
    tourBackground: 'rgb(207, 207, 207)',
    tourOn: 'rgb(0, 0, 0)',
    dataTableHeaderBackground: 'rgba(230, 230, 230, 1)',
    dataTableHeaderOn: 'rgb(0, 0, 0)',
    dataTableHeaderHoverBackground: 'rgb(255, 255, 255)',
    dataTableHeaderHoverOn: 'rgb(0, 0, 0)',
    dataTableFooterBackground: 'rgba(230, 230, 230, 1)',
    dataTableFooterOn: 'rgb(0, 0, 0)',
    dataTableRowOddBackground: 'rgba(250, 250, 250, 1)',
    dataTableRowOddOn: 'rgb(0, 0, 0)',
    dataTableRowEvenBackground: 'rgba(250, 250, 250, 1)',
    dataTableRowEvenOn: 'rgb(0, 0, 0)',
    dataTableRowBorder: 'none',
    dataTableRowHoverBackground: 'rgba(230, 230, 230, 1)',
    dataTableRowHoverOn: 'rgb(0, 0, 0)',
    dataTableRowSelectedBackground: 'rgba(210, 210, 210, 1)',
    dataTableRowSelectedOn: 'rgb(0, 0, 0)',
    dataTableResizer: 'rgba(136, 136, 136, 1)',
    dataTableActionIcon: 'inherit',
    dataTableActionIconSelected: 'inherit',
    dataTableActionIconHover: 'inherit',
    dataTableSortIcon: 'inherit',
    dataTableSortIconActive: 'rgba(141, 206, 215, 1)',
    dataTableNavigationIcon: 'inherit',
    dataTableNavigationIconHover: 'inherit',
    dataTableNavigationIconBackground: 'rgba(0,  0,  0, 0.1)',
    dataTableNavigationIconHoverBackground: 'rgba(0,  0,  0, 0.3)',
    dataTableBodyBackground: 'transparent',
    dataTableBodyOn: 'inherit',
    selectionComponentBackground: 'rgba(250, 250, 250, 1)',
    selectionComponentOn: 'rgba(0, 0, 0, 1)',
    selectionComponentHoverBackground: 'rgba(230, 230, 230, 1)',
    selectionComponentHoverOn: 'rgb(0, 0, 0)',
    selectionComponentSelectedBackground: 'rgba(210, 210, 210, 1)',
    selectionComponentSelectedOn: 'rgb(0, 0, 0)',
    masterDetailResizer: 'rgb(207, 207, 207)',
    stepperNumberIndicatorBackground: 'rgba(0,  0,  0, 0.1)',
    stepperNumberIndicatorOn: 'inherit',
    stepperLineSeparator: 'rgba(0,  0,  0, 0.2)',
    progressBarBackground: 'rgba(0, 0 , 0, 0.15)',
    buttonBackground: 'rgba(250, 250, 250, 1)',
    buttonOn: 'rgba(0, 0, 0, 1)',
    calendarBackground: 'rgb(230, 230, 230)',
    calendarOn: 'rgb(0, 0, 0)',
    calendarSelectedBackground: 'rgba(255, 255, 255, 1)',
    calendarSelectedOn: 'rgba(210, 55, 45, 1)',
    calendarHoverBackground: 'rgba(0,  0,  0, 0.2)',
    calendarHoverOn: 'inherit',
    calendarDivider: 'rgba(0,  0,  0, 0.2)',
    calendarInactiveMonthBackground: 'none',
    calendarInactiveMonthOn: 'inherit',
    calendarActiveMonthBackground: 'rgba(0,  0,  0, 0.05)',
    calendarActiveMonthOn: 'inherit',
    timePickerBackground: 'rgb(230, 230, 230)',
    timePickerOn: 'rgb(0, 0, 0)',
    timePickerTimeUnitBackground: 'rgba(0,  0,  0, 0.05)',
    timePickerTimeUnitOn: 'inherit',
    timePickerActiveTimeUnitBackground: 'rgba(255, 255, 255, 1)',
    timePickerActiveTimeUnitOn: 'rgba(0, 0, 0, 1)',
    timePickerKeypadBackground: 'rgba(0,  0,  0, 0.05)',
    timePickerKeypadOn: 'inherit',
    timePickerKeypadHoverBackground: 'rgba(0,  0,  0, 0.05)',
    timePickerKeypadHoverOn: 'inherit',
    administrativeLabelsTextFill: 'rgba(102, 102, 102, 1)',
    administrativeLabelsTextStroke: 'rgba(161, 161, 161, 1)',
    landscapeLabelsTextFill: 'rgba(102, 102, 102, 1)',
    landscapeLabelsTextStroke: 'rgba(161, 161, 161, 1)',
    landscapeManmadeAll: 'rgba(239, 64, 53, 1)',
    landscapeNaturalGeometry: 'rgba(243.28623853211008, 115.16697247706423, 107.11376146788989, 1)',
    landscapeNaturalTerrainGeometry: 'rgba(239, 64, 53, 1)',
    poiGeometry: 'rgba(43, 43, 43, 1)',
    poiLabelsTextFill: 'rgba(200, 200, 200, 1)',
    poiLabelsTextStroke: 'rgba(239, 64, 53, 1)',
    transitGeometryFill: 'rgba(255, 255, 255, 1)',
    transitLabelsTextFill: 'rgba(0, 0, 0, 1)',
    transitLabelsTextStroke: 'rgba(210, 210, 210, 1)',
    roadGeometry: 'rgba(141, 206, 215, 1)',
    roadLabelsTextFill: 'rgba(0, 0, 0, 1)',
    roadLabelsTextStroke: 'rgba(88, 183, 197, 1)',
    waterAll: 'rgba(43, 43, 43, 1)',
    waterLabels: 'rgba(230, 230, 230, 1)',
    skeletonBackground: 'rgb(255, 255, 255)',
    skeletonFill: 'rgb(255, 255, 255)',
    skeletonAnimationColor: 'rgb(255, 255, 255)',
    skeletonTextColor: 'rgba(102, 102, 102, 1)',
    switchOnBackground: 'rgba(255,  255,  255, 1)',
    switchOffBackground: 'rgb(138, 138, 138)',
    fontName: 'fjalla-lato',
    fontFamilyHeaders: 'Montserrat-600, sans-serif',
    fontFamily: 'Lato-400, sans-serif',
    fontBase: '1rem Lato-400, sans-serif',
    textBase: '1rem',
    textScaling: '1.25',
    textXs: 'calc(1rem / (1.25 * 1.25))',
    textSm: 'calc(1rem / 1.25)',
    textMd: 'calc(1rem * 1.25)',
    textLg: 'calc(var(--text-md) * 1.25)',
    textXl: 'calc(var(--text-lg) * 1.25)',
    textXxl: 'calc(var(--text-xl) * 1.25)',
    textXxxl: 'calc(var(--text-xxl) * 1.25)',
    fontH1: 'var(--text-xxxl) Fjalla-600, sans-serif',
    fontH2: 'var(--text-xxl) Fjalla-600, sans-serif',
    fontH3: 'var(--text-xl) Fjalla-500, sans-serif',
    fontH4: 'var(--text-lg) Fjalla-500, sans-serif',
    fontH5: 'var(--text-md) Fjalla-500, sans-serif',
    fontH6: 'var(--text-base) Fjalla-400, sans-serif',
    mainDivider: 'rgba(0,  0,  0, 0.2)',
    surfaceDivider: 'rgba(0,  0,  0, 0.2)',
    modalDivider: 'rgba(0,  0,  0, 0.2)',
    modalSurfaceDivider: 'rgba(0,  0,  0, 0.2)',
    themeName: 'scala-light',
    themeType: 'light',
    fonts: 'montserrat',
    dataTableRowActiveBackground: 'rgba(210, 210, 210, 1)',
    dataTableRowActiveOn: 'rgb(0, 0, 0)'
};
